import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex w-full items-center"
}
const _hoisted_2 = {
  class: /*#__PURE__*/_normalizeClass(`flex h-5 items-center justify-center text-white`)
}
const _hoisted_3 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(`text-[13px] text-white duration-300 ease-in-out group-hover:scale-105`)
}
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_tree_list = _resolveComponent("tree-list", true)!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([`transform duration-300 ease-in-out ${
      _ctx.sidebarStore.isSidebarOpened ? 'translate-x-0' : '-translate-x-10'
    }`, "w-full"]),
    style: _normalizeStyle(_ctx.itemMargin)
  }, [
    (_ctx.checkIfRouteIsDisplayed(_ctx.route))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(), _createBlock(_component_router_link, {
            key: _ctx.route?.name,
            to: { name: _ctx.route?.name },
            class: "w-full"
          }, {
            default: _withCtx(({ isActive }) => [
              (_ctx.route.meta?.showInNavigation)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(`mb-1 flex items-center ${
            !_ctx.sidebarStore.isSidebarOpened && 'justify-center'
          } text-md space-x-2 ${
            isActive && 'bg-primary '
          } group  rounded-md px-2 py-2 duration-300  ease-in-out hover:bg-primary`)
                  }, [
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: _ctx.route.meta?.icon
                      }, null, 8, ["icon"])
                    ])), [
                      [_directive_tippy, {
              arrow: true,
              content: _ctx.$t(_ctx.route.meta?.label),
              display: !_ctx.sidebarStore.isSidebarOpened,
            }]
                    ]),
                    (_ctx.sidebarStore.isSidebarOpened)
                      ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_ctx.$t(_ctx.route.meta?.label)), 1))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["to"])),
          (_ctx.hasChildren && _ctx.sidebarStore.isSidebarOpened)
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 0,
                class: _normalizeClass(`absolute right-2 transform cursor-pointer p-2 text-white duration-200 ease-in-out hover:text-primary ${
          _ctx.showChildren ? 'rotate-90' : 'rotate-0'
        }`),
                icon: ['fas', 'chevron-right'],
                onClick: _ctx.toggleChildren
              }, null, 8, ["class", "onClick"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasChildren && _ctx.showChildren && _ctx.sidebarStore.isSidebarOpened)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.route?.children, (child) => {
            return (_openBlock(), _createElementBlock("div", {
              key: child?.name
            }, [
              (
            !child.meta?.authorize ||
            _ctx.permissionStore.hasPermissionView(child.meta?.authorize)
          )
                ? (_openBlock(), _createBlock(_component_tree_list, {
                    key: 0,
                    route: child,
                    spacing: _ctx.spacing + 16
                  }, null, 8, ["route", "spacing"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 6))
}